import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c97f7e58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c97f7e58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f7e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c97f7e58')) {
      api.createRecord('c97f7e58', component.options)
    } else {
      api.reload('c97f7e58', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c97f7e58&scoped=true", function () {
      api.rerender('c97f7e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/saLogin/index.vue"
export default component.exports